import { Field } from '@sitecore-jss/sitecore-jss-nextjs';
import {
  AnchorTargetParams,
  RenderingProps,
  TranslationOptionsParams,
} from 'src/shared/shared.types';

export type I01SparkleProviderOrLocationSearchProps = RenderingProps<
  I01SparkleProviderOrLocationSearchFields,
  I01SparkleProviderOrLocationSearchParams
>;

export type I01SparkleProviderOrLocationSearchFields = {
  UUID?: Field<string>;
  ContainerID?: Field<string>;
};

export type I01SparkleProviderOrLocationSearchParams = AnchorTargetParams &
  TranslationOptionsParams;
